import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { next } from '@ember/runloop';
import { inject as service } from '@ember/service';
import LoginIndexController from 'cio/pods/login/index/controller';
import AlertsService from 'cio/services/alerts';
import AuthService from 'cio/services/auth';
import { getTwoFactorAuthLinkCookie } from 'cio/utils/auth-cookies';
import SessionService from 'cio/services/session';

export default class LoginIndexRoute extends Route {
  @service alerts!: AlertsService;
  @service auth!: AuthService;
  @service session!: SessionService;

  setupController(controller: LoginIndexController, model: Record<string, any>, transition: Transition) {
    super.setupController(controller, model, transition);

    if (controller.loggedOut) {
      this.alerts.success('loggedOut.success', 'Logged out');

      next(this, () => {
        controller.set('loggedOut', null);
      });
    }

    // convenience feature: pre-filling e-mail input based on a query param
    // happens when clicking "Join the team" links in SSO-enabled team invitation e-mails
    if (controller.email != null) {
      controller.loginController.set('email', controller.email);
      controller.set('email', null);
      controller.submitTask.perform();
    }
    // persist origin value to retrive the value after login
    // this is necessary since login usually includes different routes so url query gets lost
    if (controller.origin != null) {
      this.session.set('redirectToAfterLogin', controller.origin);
    }
  }

  redirect() {
    if (getTwoFactorAuthLinkCookie() != null) {
      return this.router.transitionTo('login.2fa_email_link');
    }

    return;
  }
}
